import { Col, Container, Row } from 'reactstrap'
import LoginForm from '../Common/LoginForm'

const LoginWithTooltipContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col xl="5" className="b-center bg-size p-0 loginImageBg3" ></Col>
        <Col xl="7" className="p-0">
          <LoginForm  />
        </Col>
      </Row>
    </Container>
  )
}

export default LoginWithTooltipContainer